import { FC } from "react";
import { useCompare } from "./Compare.hook";
import { CompareView } from "./CompareView";
import { Picker } from "./Picker";
import { LoadingIndicator } from "../../components/LoadingIndicator";
import { Button } from "../../components/Button";
import { COMPARASION_KEYS } from "./Compare.consts";
import "./style.css";

export const Compare: FC = () => {
  const {
    envs,
    disableCompareButton,
    firstEnv,
    secondEnv,
    compareData,
    showComparison,
    filterItems,
    compareKey,
    error,
    isLoading,
    onComparisonKeyClick,
    onFirstEnvClick,
    onSecondEnvClick,
    onFilterChange,
    onCompareClick,
  } = useCompare();

  const { firstEnvData, secondEnvData } = compareData;

  return (
    <div className="app">
      <Picker
        label="Select first enviroment"
        items={envs}
        currentPickedItem={firstEnv}
        onItemClick={onFirstEnvClick}
      />
      <Picker
        label="Select second enviroment"
        items={envs}
        currentPickedItem={secondEnv}
        onItemClick={onSecondEnvClick}
      />
      <Picker
        label="Select what to compare"
        items={COMPARASION_KEYS}
        currentPickedItem={compareKey}
        onItemClick={onComparisonKeyClick}
      />
      <Button onClick={onCompareClick} disabled={disableCompareButton}>
        Compare
      </Button>
      <div className="app-loader-wrapper">
        {isLoading && <LoadingIndicator isLoading={isLoading} size={80} />}
      </div>
      {error && <p>{error} :(</p>}
      {showComparison && (
        <CompareView
          firstEnv={firstEnv}
          secondEnv={secondEnv}
          compareKey={compareKey}
          firstEnvData={firstEnvData}
          secondEnvData={secondEnvData}
          filterItems={filterItems}
          onFilterChange={onFilterChange}
        />
      )}
    </div>
  );
};
